import Currency from "../models/Currency";
export const CurrencyMixin = {
  data() {
    return {
      currency: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Currency({
        name: undefined,
        acronym: undefined,
        symbol: undefined,
        decimals: 2,
        matchmaking_threshold: 0,
        is_fiat: false,
      })
    }
  }
}
